import { useEffect, useState } from "react";
import axios from "axios";

// What /api/photos/public says is on sale: { price, idPrice }, each null while the
// admin hasn't set it. null until it answers, and when it fails. Asked once per page
// load and shared: the navbar, the home page's hero and PhotoCta all offer photos
// only while they are on sale.
let offer = null;

const ask = () => {
  if (!offer) {
    offer = axios
      .get("/api/photos/public")
      .then((res) => ({
        price: res.data.price || null,
        idPrice: (res.data.id && res.data.id.price) || null,
      }))
      .catch(() => {
        // The next one to ask tries again
        offer = null;
        return null;
      });
  }
  return offer;
};

const usePhotoOffer = () => {
  const [value, setValue] = useState(null);

  useEffect(() => {
    let live = true;
    ask().then((result) => {
      if (live) setValue(result);
    });
    return () => {
      live = false;
    };
  }, []);

  return value;
};

export default usePhotoOffer;
